import clsx from "clsx";
import PropTypes from "prop-types";
import { useContext } from "react";
import { sanitizeTextForTestId } from "../../../utils";
import { RlNavContext } from "./RlNav";
import RlNavItemInnerContent from "./RlNavItemInnerContent";

const RlNavItem = ({
  show = true,
  navKey,
  text,
  label,
  icon,
  link,
  helpText,
  className,
  noDot = false,
  "data-testid": dataTestId
}) => {
  const { activeKey, setActiveKey } = useContext(RlNavContext);
  const activeNavItem = activeKey === navKey;

  const itemClassNames = clsx(
    "rl-nav__item rl-nav__item--basic",
    activeNavItem && "rl-nav__item--active",
    noDot && "rl-nav__item--no-dot",
    className
  );

  const handleNavClick = () => {
    if (!navKey) return;
    setActiveKey(navKey);
  };

  if (!show) {
    return null;
  }

  return (
    <RlNavItemInnerContent
      className={itemClassNames}
      onClick={handleNavClick}
      link={link}
      icon={icon}
      text={text}
      label={label}
      helpText={helpText}
      data-testid={dataTestId || sanitizeTextForTestId(text)}
    />
  );
};

RlNavItem.propTypes = {
  show: PropTypes.bool,
  navKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  label: PropTypes.node,
  icon: PropTypes.string,
  image: PropTypes.shape({
    src: PropTypes.string,
    alt: PropTypes.string
  }),
  link: PropTypes.string,
  helpText: PropTypes.string,
  className: PropTypes.string,
  noDot: PropTypes.bool,
  "data-testid": PropTypes.string
};

export default RlNavItem;
